<template src="./equipment_sizes.html">

</template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

export default {
  name: "EquipmentSizes",
  data() {
    return {
      current_id: null,
      currentPage: 1,
      form_data: {
        id: null,
        iso_code: '',
        size: '',
      },
      equipment_sizes: [],
      id2Delete: null,
      perPage: 10,
      showAlert: false,
      showModal: false,      
      total_rows: 0,
    }
  },
  watch: {
    currentPage: {
      handler(newPage, oldPage) {
    
        console.log(`Page changed from ${oldPage} to ${newPage}`)
      }
    }
  },   
  computed: {
    paginatedEquipmentSizes() {

      return this.equipment_sizes
    },
    totalRows() {this.totalRows = this.totalRows / this.perPage

      return this.equipment_sizes.length
    }
  },  
  mounted() {

    this.loadEquipmentSizesList()
  },
  methods: {
    cancelEquipmentSize() {

      this.current_id = null
      this.form_data = {
        id: null,
        iso_code: '',
        size: '',
      }
    },
    async deleteRecord(equipment_size) {

      console.debug("deleteRecord(id)", equipment_size)
      this.id2Delete = equipment_size.id
      this.showModal = true
    },    
    editRow(equipment_size) {

      this.current_id = equipment_size.id
      this.form_data.id = equipment_size.id
      this.form_data.iso_code = equipment_size.iso_code
      this.form_data.size = equipment_size.size
    },    
    async handleDelete() {

      try {
      
        const url = API_URL + "various/EquipmentSizesDetail/" + this.id2Delete + "/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.delete(url, {headers})
        this.showModal = false
        this.current_id = null
        await this.loadEquipmentSizesList()
      } 
      catch (error) {
      
        console.debug("handleDelete() error", error)
        if(error.response.status == 500) {
          
          this.alertMsg = "Attenzione! La dimensione dell'equipaggiamento risulta essere utilizzata da almeno una riga di listino. Per rimuoverlo di devono prima rimuovere tutte le righe di listino che utilizzano questa dimensione equipaggiamento"
          this.showAlert = true
        }
      }
    },
    handlePageChange(page) {

      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadEquipmentSizes()
      })
    },    
    async insertEquipmentSize() {

      const url = API_URL+"various/EquipmentSizesDetail/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }      
      const response = await axios.post(url, this.form_data, {headers})
      this.cancelEquipmentSize()
      this.loadEquipmentSizesList()
    },
    async loadEquipmentSizesList() {

      const url = API_URL + "various/EquipmentSizesList/"
      const axiosInstance = axios.create({
        headers: {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        },
      })
      
      try {

        const response = await axiosInstance.get(url)
        this.equipment_sizes = response.data.map(equipment_size => ({
          id: equipment_size.id,
          iso_code: equipment_size.iso_code,
          size: equipment_size.size,
        }))
        this.total_rows = this.equipment_sizes.length
      } 
      catch(error) {
      
        console.log('Failed to load equipment_sizes list:', error)
      }      
    },
    onPageChange(page) {
      
      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadEquipmentSizesList()
      })
    },    
    onPerPageChange(newPerPage) {
    
      this.perPage = newPerPage
      this.currentPage = 1
      this.loadEquipmentSizesList()
    },
    onSortChanged(ctx) {
      
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
    },    
    async selectEquipmentSize(row) {

      this.current_id = row.id
      const url = API_URL+"various/EquipmentSizesDetail/"+row.id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.get(url, {headers: headers})
      this.form_data = response.data
    },    
    async updateEquipmentSize() {

      const url = API_URL+"various/EquipmentSizesDetail/"+this.current_id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.patch(url, this.form_data, {headers})
      this.cancelEquipmentSize()
      this.loadEquipmentSizesList()
    },
  },
}

</script>
